var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgClockIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 12,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6 0C2.692 0 0 2.692 0 6s2.692 6 6 6 6-2.692 6-6-2.692-6-6-6Zm3.45 6.6H5.4V2.4h1.2v3h2.85v1.2Z",
  fill: "#00BAC6"
})));
export { SvgClockIcon as ReactComponent };
export default __webpack_public_path__ + "e56658f8bfa18a496be6c719bfee4bc3.svg";